import React, { useState, useEffect } from 'react';
import trainRoutes from '../data/trainRoutes.json';

const TrainUtil = () => {
    const [departures, setDepartures] = useState({});
    const [loading, setLoading] = useState(true);

    const ACCESS_TOKEN = "f875c012-3fb4-4075-99c7-1dee11afb046";

    // Test URL: https://huxley2.azurewebsites.net/departures/MOG/to/HRN/3?expand=true
    const demoServers = [
        'https://huxley2.azurewebsites.net'
    ];

    const fetchDepartures = async () => {
        const results = {};
        let workingServer = null;

        for (const route of trainRoutes) {
            let success = false;
            // Try servers starting with the one that last worked, or the first in the list
            const serversToTry = workingServer
                ? [workingServer, ...demoServers.filter(s => s !== workingServer)]
                : demoServers;

            for (const server of serversToTry) {
                try {
                    const url = `${server}/departures/${route.from}/to/${route.to}/3?expand=true&accessToken=${ACCESS_TOKEN}`;

                    const response = await fetch(url);
                    if (response.ok) {
                        const data = await response.json();
                        results[`${route.from}-${route.to}`] = data.trainServices || [];
                        workingServer = server;
                        success = true;
                        break;
                    }
                } catch (e) {
                    console.warn(`Huxley server ${server} failed for ${route.from}:`, e);
                }
            }

            if (!success) {
                results[`${route.from}-${route.to}`] = [];
            }
        }

        setDepartures(results);
        setLoading(false);
    };

    useEffect(() => {
        fetchDepartures();
    }, []);

    return (
        <section id="train-util">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <h2>Train Util</h2>
                        <hr className="star-primary" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-10 col-lg-offset-1">
                        <div className="text-center" style={{ marginBottom: '20px' }}>
                            <button className="btn btn-success" onClick={() => { setLoading(true); fetchDepartures(); }}>
                                <i className="fa fa-refresh"></i> Refresh
                            </button>
                        </div>

                        {loading && Object.keys(departures).length === 0 ? (
                            <p className="text-center">Loading train data...</p>
                        ) : (
                            trainRoutes.map((route, rIndex) => (
                                <div key={rIndex} style={{ marginBottom: '40px' }}>
                                    <h3 className="text-center">{route.fromName} <i className="fa fa-arrow-right" style={{ fontSize: '0.8em', margin: '0 10px' }}></i> {route.toName}</h3>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped" style={{ marginTop: '10px' }}>
                                            <thead>
                                                <tr>
                                                    <th>Dep.</th>
                                                    <th>Arr.</th>
                                                    <th>Dest.</th>
                                                    <th>Plat.</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {departures[`${route.from}-${route.to}`]?.length > 0 ? (
                                                    departures[`${route.from}-${route.to}`].map((service, sIndex) => {
                                                        // Find arrival time at our destination (route.to)
                                                        let arrivalTime = 'N/A';
                                                        if (service.subsequentCallingPoints) {
                                                            for (const group of service.subsequentCallingPoints) {
                                                                const point = group.callingPoint?.find(cp => cp.crs === route.to);
                                                                if (point) {
                                                                    arrivalTime = point.st;
                                                                    if (point.et && point.et !== 'On time') {
                                                                        arrivalTime += ` (${point.et})`;
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                        }

                                                        const isDelayed = service.etd !== 'On time' && service.etd !== service.std;

                                                        return (
                                                            <tr key={sIndex}>
                                                                <td style={{ fontWeight: 'bold' }}>
                                                                    {service.std}
                                                                    {isDelayed && (
                                                                        <span style={{ color: '#d9534f', marginLeft: '5px' }}>({service.etd})</span>
                                                                    )}
                                                                </td>
                                                                <td>{arrivalTime}</td>
                                                                <td>{service.destination?.[0]?.locationName || 'N/A'}</td>
                                                                <td>{service.platform || '-'}</td>
                                                                <td>
                                                                    <span className="label"
                                                                        style={{
                                                                            color: 'white',
                                                                            backgroundColor: service.etd === 'On time' ? '#18bc9c' : '#f39c12',
                                                                            padding: '4px 8px',
                                                                            borderRadius: '4px',
                                                                            fontSize: '0.8em'
                                                                        }}>
                                                                        {service.etd}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">
                                                            {loading ? 'Fetching...' : 'No upcoming services found.'}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ))
                        )}
                        <div className="text-center" style={{ fontSize: '0.8em', color: '#777', marginTop: '20px' }}>
                            Data provided by National Rail Darwin API.
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrainUtil;
